import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CaiInfoModal } from "../components/cai-info-modal/CaiInfoModal";
import CaiPreviewsCmp from "../components/cai-preview/CaiPreviewsCmp";
import CancelConfirmIdentityModal from "../components/cancel-confirm-identity/CancelConfirmIdentityModal";
import LoaderCmp from "../components/loader/LoaderCmp";
import { RealtimeModal } from "../components/modal/RealtimeModal";
import { NextButton, SecondChoiseButton } from "../components/styled/Button.style";
import { Section } from "../components/styled/Containers.style";
import { InfoIcon } from "../components/styled/Icon.style";
import { Vspace } from '../components/styled/Separators.style';
import { PageTitle, TextDefault } from "../components/styled/Text.style";
import { PATHS } from "../routes/CaiExperienceRouter";
import { selectCommunicationData } from "../store";
import { saveCommunicationAct } from "../store/communication-data/actions";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { CommunicationType, EventCommType, EventValueEnum } from "../types/communication/communicationDataType";
import { usePrivacyCheckCmp } from "../utils/hooks/usePrivacyCheckCmp";
import { composeUrl, getPathIfTractable, hasCaiSecondPageData } from "../utils/utils";
import PageContainerCmp from "./PageContainerCmp";

/* istanbul ignore next */
const CaiPreviewPage = () => {
    const communicationData = useAppSelector(selectCommunicationData)
    const { invokeSignatureMetadata, communication } = communicationData
    const dispatch = useAppDispatch();
    let navigate = useNavigate();
    let { token } = useParams();
    const previewUrlPage_1 = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}/dinamica-attachment/full-page`;
    const previewUrlPage_2 = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}/dinamica-attachment/second-full-page`;
    const isCaiSecondPageVisible = hasCaiSecondPageData(communication)
    const { privChecked, PrivCheckedCmp } = usePrivacyCheckCmp(communication.authConfirmPrivacyChecked)

    const [openCaiModal, setOpenCaiModal] = useState(false)
    const [cancelModalOpened, setCancelModalOpened] = useState<boolean>(false)

    const shouldDisableButton = () => {
        return !(privChecked?.value);
    }

    const goToNextStepHandler = () => {
        //const _pathname = composeUrl(token, PATHS.END_SIGNATURE_FORWARD_SUCCESS)
        const _pathname = composeUrl(token, PATHS.CHOOSE_SIGNATURE_AUTHENTICATION)
        const newEvent = new EventCommType({ value: EventValueEnum.CAI_FILLING_END })
        const data = new CommunicationType({
            ...communication,
            authConfirmPrivacyChecked: privChecked.value
        })

        // CONDIZIONI SOPPRESSE PERCHE' CON L'ENTRATA IN VIGORE DI FEA E FEQ IL DOCUMENTO D'IDENTITA' DIVENTA INUTILE
        // if it is in app, then directly invoke the signature process
        // If it is web app, then pass from confirm identity step
        //const _inApp = isInApp()
        //const isTractableActive = !!communication.tractableOn
        //if (_inApp || isTractableActive) {
        dispatch(saveCommunicationAct({
            data,
            events: [newEvent],
            callback: () => navigate(_pathname)
        }))

        /*} else {
            const _confirmIdentityPath = composeUrl(token, PATHS.CONFIRM_IDENTITY)
            dispatch(saveCommunicationAct({
                data,
                events: [],
                callback: () => navigate(_confirmIdentityPath)
            }))
        }*/
    }

    const _backPath = getPathIfTractable(communication.tractableOn, PATHS.TRCT_FOTO_OTHER_USEFUL_INFO, PATHS.CAI_DATI_CONTROPARTE)

    return (
        <>

            <CancelConfirmIdentityModal
                modalOpened={cancelModalOpened}
                onCloseHandler={() => setCancelModalOpened(false)} />

            <RealtimeModal
                modalOpened={openCaiModal}
                hTitle="Constatazione amichevole"
                hCloseButton={true}
                /* istanbul ignore next */
                onCloseHandler={() => setOpenCaiModal(false)}>
                <CaiInfoModal />
            </RealtimeModal>

            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={PATHS.CAI_PREVIEW}
                removeNextBtn
                backPath={_backPath}
            >
                <>
                    {invokeSignatureMetadata?.isLoading && <LoaderCmp className="cover cai-preview" />}
                    <Section>
                        <PageTitle>Constatazione amichevole <InfoIcon icon={faCircleInfo} onClick={() => setOpenCaiModal(true)} /></PageTitle>
                        <Vspace></Vspace>
                        <TextDefault centered sm>Le informazioni del sinistro che ci hai condiviso sono state inserite nel modulo di constatazione amichevole che vedi qui sotto.</TextDefault>
                        <Vspace></Vspace>
                        <TextDefault centered sm>Procedendo con la firma sarai reindirizzato al completamento.</TextDefault>
                    </Section>

                    <Section>
                        <CaiPreviewsCmp
                            previewUrlPage_1={previewUrlPage_1}
                            previewUrlPage_2={previewUrlPage_2}
                            isCaiSecondPageVisible={isCaiSecondPageVisible}
                        ></CaiPreviewsCmp>
                    </Section>

                    {PrivCheckedCmp}

                    <Section>
                        <Vspace></Vspace>
                        <NextButton
                            disabled={shouldDisableButton()}
                            onClick={goToNextStepHandler}>Avanti</NextButton>
                        <Vspace></Vspace>
                        <SecondChoiseButton onClick={() => setCancelModalOpened(true)}>Non voglio firmare</SecondChoiseButton>
                    </Section>
                </>
            </PageContainerCmp>
        </>

    )
}

export default CaiPreviewPage